import { useKeycloak } from "../../components/keycloak-provider";
import { useEffect, useMemo } from "react";
import { useUserPropertyTickers } from "../../components/user-tickers-providers";
import { useHistory, useParams } from "react-router";
import { useUserProfile } from "../../components/user-profile-provider";

interface RouteParams {
  propertyTicker?: string;
}

export const INITIAL_PATH = "/reservations";

export function Login() {
  const keycloak = useKeycloak();
  const { propertyTicker: propertyTickerParam } = useParams<RouteParams>();
  const history = useHistory();
  const userProfile = useUserProfile();
  const propertyTickers = useUserPropertyTickers();
  const lastPropertyTicker = window.sessionStorage.getItem("lastPropertyTicker");

  const propertyTicker = useMemo(() => {
    if (propertyTickerParam && propertyTickers.includes(propertyTickerParam)) {
      return propertyTickerParam
    }
    if (lastPropertyTicker && propertyTickers.includes(lastPropertyTicker)) {
      return lastPropertyTicker
    }
    return propertyTickers[0];
  }, [propertyTickerParam, propertyTickers, lastPropertyTicker]);

  useEffect(() => {
    if (keycloak.authenticated && userProfile?.email && propertyTickers.length) {
      history.push(`/${propertyTicker}${INITIAL_PATH}`);
    }
  }, [keycloak.authenticated && userProfile?.email, propertyTickers]);
}
